import fetch from '@/utils/fetch';

//统计各个学校的短信使用情况
export function statisticGroupBySchoolId(listQuery) {
    let params = new URLSearchParams();
    params.append('pageNo', listQuery.pageNo);
    params.append('pageSize', listQuery.pageSize);
    params.append('schoolName', listQuery.schoolName);
    return fetch({
        url: 'structure/smsRecharge/statisticGroupBySchoolId',
        method: 'get',
        params
    });
  }
//提醒学校管理员余量不足
export function remindSchoolManager(schoolId) {
    let params = new URLSearchParams();
    params.append('schoolId', schoolId);
    return fetch({
        url: 'structure/smsRecharge/remindSchoolManager',
        method: 'GET',
        params
    });
}
//充值
export function insert(args) {
    return fetch({
        headers: {
            'content-type': 'application/json'
        },
        url: 'structure/smsRecharge/insert',
        method: 'POST',
        data: JSON.stringify(args)
    });
  }
//单个学校短信概览
export function listByModel(schoolId,type) {
    let params = new URLSearchParams();
    params.append('schoolId', schoolId);
    params.append('type', type);
    return fetch({
        url: 'structure/smsRecharge/listByModel',
        method: 'GET',
        params
    });
}
//审批
export function approve(args) {
    return fetch({
        headers: {
            'content-type': 'application/json'
        },
        url: 'structure/smsRecharge/approve',
        method: 'POST',
        data: JSON.stringify(args)
    });
  }
  //删除充值记录
export function deleteById(id) {
    let params = new URLSearchParams();
    params.append('id', id);
    return fetch({
        url: 'structure/smsRecharge/deleteById',
        method: 'GET',
        params
    });
}
//全平台充值记录(分页)
export function listPageAllRecharge(listQuery) {
    let params = new URLSearchParams();
    params.append('pageNo', listQuery.pageNo);
    params.append('pageSize', listQuery.pageSize);
    params.append('schoolName', listQuery.schoolName);
    params.append('type', listQuery.type);
    return fetch({
        url: 'structure/smsRecharge/listPageAllRecharge',
        method: 'get',
        params
    });
  }


// WEBPACK FOOTER //
// ./src/api/shortmessage.js